/**
 * SuperStock RC — Minimalista YouTube Lazy Loader (v3)
 * Uses Swiper API directly + intercepts Minimalista's own video logic.
 */

(function () {
  'use strict';

  // ─── Step 1: Blank ALL youtube iframes immediately, before anything else ───
  // Run inline before DOMContentLoaded so we beat Minimalista's init
  function blankAllIframes() {
    document.querySelectorAll('iframe[data-id]').forEach(function (iframe) {
      var src = iframe.getAttribute('src');
      if (src && src.includes('youtube')) {
        // Save original src
        if (!iframe.getAttribute('data-lazy-src')) {
          iframe.setAttribute('data-lazy-src', src);
        }
        iframe.setAttribute('src', 'about:blank');
      }
    });
  }

  // Run immediately
  blankAllIframes();

  // ─── Step 2: Override iframe src setter so Minimalista can't restore it ───
  // Minimalista sets iframe.src = '...' via JS — we intercept that
  var nativeSrcDescriptor = Object.getOwnPropertyDescriptor(HTMLIFrameElement.prototype, 'src');

  Object.defineProperty(HTMLIFrameElement.prototype, 'src', {
    set: function (val) {
      // Only intercept YouTube iframes that we're managing
      if (val && val.includes('youtube') && this.hasAttribute('data-id')) {
        // Save it but don't apply — we'll apply it when the slide is active
        this.setAttribute('data-lazy-src', val
          .replace('autoplay=1', 'autoplay=0')
          .replace('&mute=1', '')
          .replace('mute=1&', '')
        );
        // Check if this iframe's slide is currently active
        var slide = this.closest('.swiper-slide');
        if (slide && slide.classList.contains('swiper-slide-active')) {
          nativeSrcDescriptor.set.call(this, val); // allow it for active slide
        } else {
          nativeSrcDescriptor.set.call(this, 'about:blank'); // block it
        }
        return;
      }
      nativeSrcDescriptor.set.call(this, val);
    },
    get: function () {
      return nativeSrcDescriptor.get.call(this);
    },
    configurable: true
  });

  // ─── Step 3: Load/unload based on active slide ───
  function loadActiveSlide() {
    document.querySelectorAll('.swiper-slide').forEach(function (slide) {
      var iframe = slide.querySelector('iframe[data-id]');
      if (!iframe) return;

      var isActive = slide.classList.contains('swiper-slide-active');

      if (isActive) {
        var lazySrc = iframe.getAttribute('data-lazy-src');
        if (lazySrc && iframe.getAttribute('src') === 'about:blank') {
          nativeSrcDescriptor.set.call(iframe, lazySrc);
        }
      } else {
        if (iframe.getAttribute('src') !== 'about:blank') {
          nativeSrcDescriptor.set.call(iframe, 'about:blank');
        }
      }
    });
  }

  // ─── Step 4: Hook into Swiper after it initialises ───
  function hookSwiper() {
    // Find Swiper instances on the page
    var swiperEls = document.querySelectorAll('.swiper-wrapper');

    swiperEls.forEach(function (wrapper) {
      var container = wrapper.closest('.swiper');
      if (!container) return;

      // If Swiper instance is already attached
      if (container.swiper) {
        container.swiper.on('slideChange', loadActiveSlide);
        container.swiper.on('init', loadActiveSlide);
      }
    });

    // Also watch via MutationObserver for swiper-slide-active class changes
    var observer = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (m) {
        return m.attributeName === 'class' &&
          (m.target.classList.contains('swiper-slide-active') ||
           m.oldValue && m.oldValue.includes('swiper-slide-active'));
      });
      if (relevant) loadActiveSlide();
    });

    document.querySelectorAll('.swiper-slide').forEach(function (slide) {
      observer.observe(slide, {
        attributes: true,
        attributeFilter: ['class'],
        attributeOldValue: true
      });
    });
  }

  // ─── Step 5: Init ───
  document.addEventListener('DOMContentLoaded', function () {
    blankAllIframes();   // blank again after DOM ready
    loadActiveSlide();   // load only the active one
    hookSwiper();        // hook into Swiper events

    // Retry after a short delay in case Swiper initialises late
    setTimeout(function () {
      blankAllIframes();
      loadActiveSlide();
      hookSwiper();
    }, 800);

    setTimeout(function () {
      blankAllIframes();
      loadActiveSlide();
    }, 2000);
  });

})();